import { axiosApi } from "../../../../../api/dbAxios";

export const fetchFieldList = async (regulator: string) => {
  try {
    const response = await axiosApi.get(
      `/add_record/regulators/${regulator}/fields/`,
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching field list", error);
    return {};
  }
};
